import 'jquery';

/**
 * toggle BIC in SEPA Screen
 */
(function ($) {

  var bic = $('#sepa_form_bic');

  $('#sepa_form_iban').on('keyup change', function () {
    const allowed = ['DE', 'AT', 'BE', 'DK', 'FR', 'IT', 'ES', 'NL', 'GB', 'FI', 'EE', 'IE', 'LI', 'LU'],
      value = $.trim($(this).val().toUpperCase().replace(/\s/gi, ''));

    var hideBic = true,
      // toggle visibility of bic
      toggleBic = function (status) {
        if (!bic.length) {
          return;
        }

        // disabled will leave input value but won't post it
        bic.prop('disabled', !status)
          .prop('required', status);

        if (status) {
          bic.closest('.form-row').removeClass('hidden');
        } else {
          bic.closest('.form-row').addClass('hidden');
        }

      };

    $(this).val(value);

    if (value && value.length > 4) {

      hideBic = false;

      for (let country in allowed) {
        if (value.slice(0, 2) === allowed[country]) {
          hideBic = true;
          break;
        }
      }
    }

    toggleBic(!hideBic);

    $(document).trigger('plenigo.resize');

  });

}(jQuery));
